export default {
  faturamentoTotal: `Faturamento total`,
  debito: `Débito à vista`,
  credito: `Crédito à vista`,
  parcelado: `Crédito parcelado`,
  ticketMedio: `Ticket médio`,
  receitaMDR: `Receita MDR`,
  receitaAntecipacao: `Receita antecipação`,
  receitaTotal: `Receita total`,
  custoAdicional: `Taxa adicional`,
  vendasPeriodo: `Vendas por período`,
  distribuicaoBandeira: `Distribuição por bandeira`
};
